<template>
    <div>
        <!-- чисто сторінка редиректа, якщо хтось раптом щось ліве в адресному рядку заб'є -->
    </div>
</template>

<script>
import Cookies from "js-cookie"; // Модуль для роботи з кукі

export default {
  created() {
    // Якщо токен є, користувач перенаправляється на сторінку кабінету
    if (Cookies.get('token')) {
      document.location.href = "https://cabinet.skyservice.online";
    } else {
      // Якщо токена немає, здійснюється перехід на домашню сторінку
      this.$router.push('/');
    }
  }
}
</script>
